import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import styles from "./styles/Documents.module.css";
import { useLanguage } from "../LanguageContext";

function Documents() {
    const [isOpen, setIsOpen] = useState(false);
    const { t } = useLanguage();
    const documents = t("documents.items");

    const toggleAccordion = () => setIsOpen((prev) => !prev);

    return (
        <div className={styles.container}>
            <div className={styles.header} onClick={toggleAccordion}>
                <h2>{t("documents.title")}</h2>
                <motion.span className={styles.toggle} animate={{ rotate: isOpen ? 45 : 0 }} transition={{ duration: 0.3 }}>
                    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M12 6.85714H6.85714V12H5.14286V6.85714H0V5.14286H5.14286V0H6.85714V5.14286H12V6.85714Z" fill="white" />
                    </svg>
                </motion.span>
            </div>

            <AnimatePresence initial={false}>
                {isOpen && (
                    <motion.div
                        className={styles.accordion}
                        initial="collapsed"
                        animate="open"
                        exit="collapsed"
                        variants={{
                            open: { height: "auto", opacity: 1 },
                            collapsed: { height: 0, opacity: 0 },
                        }}
                        transition={{ duration: 0.4, ease: "easeInOut" }}
                    >
                        {documents.map((doc, index) => (
                            <div key={index} className={styles.documentRow}>
                                <span>{doc.name}</span>
                                <div className={styles.actions}>
                                    <a href={doc.link} download>
                                        {t("documents.download")}
                                        <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path
                                                d="M12 7.05651L11.077 6.29606L6.65274 9.94129V0H5.34726V9.94129L0.922977 6.29606L0 7.05651L6 12L12 7.05651Z"
                                                fill="white"
                                            />
                                        </svg>
                                    </a>
                                    <a href={doc.link} target="_blank" rel="noopener noreferrer">
                                        {t("documents.open")}
                                        <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path
                                                d="M2.53685 1.45587H9.51483L0 10.9707L1.0293 12L10.5441 2.48517V9.46315H12V0H2.53685V1.45587Z"
                                                fill="white"
                                            />
                                        </svg>
                                    </a>
                                </div>
                            </div>
                        ))}
                    </motion.div>
                )}
            </AnimatePresence>
        </div>
    );
}

export default Documents;
